import comp from "./AssessmentToolPreviewCard";
export default comp;
